import { Flex } from '@uhg-abyss/web/ui/Flex';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Text } from '@uhg-abyss/web/ui/Text';
import { useTranslation } from 'react-i18next';

export interface Props {
  handleBackButton: () => void;
  handleCrossButton: () => void;
  headingTitle?: string;
  headingOffset?: number;
}

export const SmartChoiceBreakDownWidgetHeader = ({
  handleBackButton,
  handleCrossButton,
  headingTitle,
  headingOffset,
}: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <Flex
        alignItems="center"
        css={{
          padding: '16px',
        }}
        justify="space-between"
      >
        <Flex
          alignItems="center"
          css={{
            cursor: 'pointer',
          }}
          data-testid="widget-back-button"
          onClick={handleBackButton}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              handleBackButton();
            }
          }}
          role="button"
          tabIndex={0}
        >
          <IconSymbol
            color="$core.color.brand.60"
            css={{
              'abyss-icon-symbol': {
                marginRight: '8px',
              },
            }}
            icon="arrow_back"
            size="16px"
            title="Back"
          />
          <Text color="$core.color.brand.60" fontWeight="bold">
            {t('BACK')}
          </Text>
        </Flex>
        <IconSymbol
          color="$core.color.brand.60"
          css={{
            cursor: 'pointer',
          }}
          data-testid="widget-cross-icon"
          icon="close"
          onClick={handleCrossButton}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              handleCrossButton();
            }
          }}
          role="button"
          size="24px"
          tabIndex={0}
          title="Close"
        />
      </Flex>
      <Heading
        css={{
          fontSize: '32.43px !important',
          lineHeight: '40px !important',
          padding: '0 16px 16px 16px',
          marginTop: headingOffset,
        }}
        data-testid="smart-choice-widget-heading"
        level={2}
        serif
        size="lg"
      >
        {headingTitle}
      </Heading>
    </>
  );
};
